(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["direct-buy-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bb-pop]').forEach((popup) => { if (!sessionStorage.getItem('bb-pop-seen')) window.setTimeout(() => { popup.hidden = false; }, 400); popup.querySelectorAll('[data-bb-close]').forEach((button) => button.addEventListener('click', () => { popup.hidden = true; sessionStorage.setItem('bb-pop-seen', '1'); })); });

  document.querySelectorAll('[data-campaign-countdown]').forEach((campaign) => {
    const timer = campaign.querySelector('.direct-buy-home__timer');
    const endAt = new Date(campaign.dataset.end).getTime();

    if (!timer || Number.isNaN(endAt)) return;

    const updateTimer = () => {
      const remaining = endAt - Date.now();

      if (remaining <= 0) {
        timer.textContent = 'This offer has ended.';
        return true;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      timer.textContent = `Ends in ${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      return false;
    };

    if (!updateTimer()) {
      const interval = window.setInterval(() => {
        if (updateTimer()) window.clearInterval(interval);
      }, 1000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-private-list-popup]');
    if (!popup) return;
    const key = 'private-list-hidden-until';
    const week = 7 * 24 * 60 * 60 * 1000;
    const setHidden = () => localStorage.setItem(key, String(Date.now() + week));
    const isHidden = () => Number(localStorage.getItem(key) || 0) > Date.now();
    const show = () => { if (!isHidden()) popup.hidden = false; };
    const success = popup.querySelector('.private-list__success');
    if (popup.dataset.privateListSubscribed === 'true') { setHidden(); return; }
    if (success) { popup.hidden = false; setHidden(); return; }
    window.setTimeout(show, 30000);
    document.addEventListener('mouseout', (event) => { if (event.clientY <= 0) show(); });
    popup.querySelector('[data-private-list-close]')?.addEventListener('click', () => { setHidden(); popup.hidden = true; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
